export const environment = {
  production: false,
  url: "https://app-dev.smartcitymarketplace.net",
  site: "scmp",
  name: "Smart City Marketplace",
};

export const SERVER_URL = "https://api-dev.smartcitymarketplace.net/api/v1";
